import { useEffect, useState } from "react";
import "../AddUserRights/AddUserRights.scss";
import AddUserRightsHeader from "./AddUserRightsHeader";
import UserRightsRows from "./UserRightsRows";
let DataArr = [
  {
    Column_name: "Access",
    name: "Page_Access",
  },
  {
    Column_name: "Add",
    name: "Is_Add",
  },
  {
    Column_name: "Edit",
    name: "Is_Edit",
  },
  {
    Column_name: "View",
    name: "Is_View",
  },
  {
    Column_name: "Delete",
    name: "Is_Delete",
  },

  {
    Column_name: "Export",
    name: "Export",
  },
  {
    Column_name: "Lock",
    name: "Is_Lock",
  },
  {
    Column_name: "Unlock",
    name: "Is_Unlock",
  },
  {
    Column_name: "Audit",
    name: "Audit",
  },
  {
    Column_name: "UnAudit",
    name: "UnAudit",
  },
];

const AddUserRights = ({ searchPage, data, handleRights }) => {
  const [stateEdit, setStateEdit] = useState({});
  const [allTick, setAllTick] = useState([]);
  const [newData, setNewData] = useState([]);
  const [PagesData, setPagesData] = useState([]);

  useEffect(() => {
    if (searchPage && PagesData?.length) {
      let filteredData = PagesData?.filter((el) => {
        let PageName = (el.Page?.Page_Name).toLowerCase();
        return PageName?.includes(searchPage.toLowerCase());
      });
      setNewData(filteredData);
    } else {
      setNewData(PagesData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchPage]);

  const handleEdit = (_id, data) => {
    const { name, checked } = data;
    setStateEdit((prev) => {
      return {
        ...prev,
        [_id]: { ...prev[_id], id: _id, [name]: checked },
      };
    });
  };

  const handleData = () => {
    let arr = [];
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].Modules.length; j++) {
        for (let k = 0; k < data[i].Modules[j].Page.length; k++) {
          let obj = {};
          obj.Master_Name = data[i].Master_Name;
          obj.Module_Name = data[i].Modules[j].Module_Name;
          obj.Page = data[i].Modules[j].Page[k];
          arr.push(obj);
        }
      }
    }
    setNewData(arr);
    setPagesData(arr);
  };
  const handleAllTickAdd = ({ name, checked }) => {
    if (checked) {
      setAllTick((prev) => {
        return {
          ...prev,
          [name]: true,
        };
      });
    } else {
      setAllTick((prev) => {
        return {
          ...prev,
          [name]: false,
        };
      });
    }
  };
  useEffect(() => {
    if (data && data.length > 0) {
      handleData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  useEffect(() => {
    handleRights(Object.values(stateEdit));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateEdit]);

  return (
    <table className="table">
      <thead>
        <tr className="table-row">
          <th className="table-header">{`Page (${newData.length})`}</th>
          <th className="table-header">Parent</th>
          <th className="table-header">Module</th>
          {DataArr &&
            DataArr.length > 0 &&
            DataArr.map((el) => (
              <AddUserRightsHeader
                Column_name={el.Column_name}
                name={el.name}
                disabled={allTick.Page_Access === undefined || allTick.Page_Access === false}
                func={(e) => handleAllTickAdd(e.target)}
              />
            ))}
        </tr>
      </thead>
      <tbody>
        {newData &&
          newData.length > 0 &&
          newData.map((el, i) => <UserRightsRows key={i} data={el} handleEdit={handleEdit} allTick={allTick} />)}
      </tbody>
    </table>
  );
};

export default AddUserRights;
